import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_GET_FINISHED}`;

export const getFinishedOrder = () => axios.get(API_PATH);
